import { normalize } from 'normalizr';
import { call, put, all, takeLatest } from 'redux-saga/effects';

import { company as companySchema } from '../../schema';
import { company, entity, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';

export function* list({ payload: { payload = {}, fullInfo } }) {
  try {
    const [response, services, workCategories] = yield all([
      call(dataProvider.getList, 'Companies', payload),
      fullInfo && call(dataProvider.getList, 'Definitions/services', {}),
      fullInfo && call(dataProvider.getList, 'Definitions/work-categories', {}),
    ]);

    const { total, data } = response;
    // normalize data
    const normalizeData = normalize(data, [companySchema]);
    yield put({ type: entity.add, payload: normalizeData.entities });

    const putPayload = fullInfo
      ? {
          list: normalizeData.result,
          total,
          services: services.data.data,
          workCategories: workCategories.data.data,
        }
      : { list: normalizeData.result, total };

    yield put({
      type: company.list.end,
      payload: putPayload,
    });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: !!e && e.message } });
  }
}

export default function* companyListPageSaga() {
  yield takeLatest(company.list.start, list);
}
